export default __webpack_public_path__ + "static/media/dark-bottom-desktop.fc26924d.webp";